toNormalizedOptions